import { render } from "./App.vue?vue&type=template&id=b9765d56&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b9765d56&lang=sass&scoped=true"
import "./App.vue?vue&type=style&index=1&id=b9765d56&lang=sass"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9765d56"]])

export default __exports__